<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="title mb-0">Você já possui cadastro</p>
    </div>
</div>

<div class="row my-2">
    <div class="col-lg-12 col-md-12 col-sm-12 m-auto text-center">
        <p class="subtitle">Por favor, faça login para continuarmos o cadastro de sua empresa</p>
    </div>
</div>

<div class="row my-3">
    <div class="col-6 m-auto">
        <!-- <form [formGroup]="gestorCadastroFormGroup" #gestorCadastroForm="ngForm" (ngSubmit)="onSubmit(gestorCadastroFormGroup.value)">
            <div class="py-2">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 m-auto py-2">
                        <div class="">
                            <div class="input-container">
                                <input formControlName="documento" id="documento" class="input" type="documento" />
                                <label class="label" for="documento">E-mail</label>
                            </div>
                            <div *ngIf="form.documento.invalid && (form.documento.dirty || form.documento.touched)" class="text-danger">
                                <div *ngIf="form.documento.errors.required">
                                    CPF é obrigatório!
                                </div>
                                <div *ngIf="form.documento.errors.cpf">
                                    CPF inválido.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 m-auto py-2">
                        <div class="">
                            <div class="input-container">
                                <input formControlName="senha" id="senha" class="input" type="password" />
                                <label class="label" for="senha">Senha</label>
                            </div>
                            <div *ngIf="form.senha.invalid && (form.senha.dirty || form.senha.touched)" class="text-danger">
                                <div *ngIf="form.senha.errors.required">
                                    Senha é obrigatória
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row button-container">
                    <div class="col-12 text-center">
                        <button type="submit" class="button">Login</button>
                    </div>
                </div>
            </div>
        </form> -->

        <form [formGroup]="loginFormGroup" #loginForm="ngForm" (ngSubmit)="onSubmit(loginFormGroup.value)">
            <div class="my-3">
                <div class="custom-input-container">
                    <input formControlName="documento" id="documento" class="custom-input" type="documento"
                        [textMask]="{mask: MASKS.cpf.textMask}" autocomplete="off"/>
                    <label class="custom-label" for="documento">CPF</label>
                </div>
                <div *ngIf="form.documento.invalid && (form.documento.dirty || form.documento.touched)"
                    class="custom-text-danger">
                    <div *ngIf="form.documento.errors.required">
                        CPF é obrigatório!
                    </div>
                    <div *ngIf="form.documento.errors.cpf">
                        CPF inválido.
                    </div>
                </div>
            </div>

            <div class="my-4">
                <div class="custom-input-container">
                    <input onlyNumber formControlName="password" id="password" type="password" class="custom-input" autocomplete="off"/>
                    <label class="custom-label" for="password">Senha</label>
                </div>
                <div *ngIf="!error && form.password.invalid && (form.password.dirty || form.password.touched)"
                    class="custom-text-danger">
                    <div *ngIf="form.password.errors.required">
                        A senha é obrigatória!
                    </div>
                </div>
            </div>



            <div *ngIf="error && !blocked" class="text-center custom-text-danger">Tentativa de login inválida. Você
                possui {{tries}} tentativas restantes.</div>
            <div *ngIf="blocked" class="text-center custom-text-danger">Tentativas de login bloqueadas por 15 minutos.
                Tente novamente após esse período.</div>

            <div class="row my-2">
                <div class="col-12 py-4 d-flex justify-content-end">
                    <button [disabled]="!loginForm.valid || blocked" type="submit" class="button">
                        <span>Entrar</span>
                        <img src="./assets/icons/arrow-right.svg">
                    </button>
                </div>
            </div>
        </form>

        <!-- div class="row text-center">
            <div class="col-6 login-option" (click)="register()">Cadastrar nova cedente</div>
        </div> -->

    </div>
</div>
